import { CrudRouter } from "javaee-fre";
const StuExceptionLogs = () => import("../views/stu-elogs.vue");
const RechargeLogs = () => import("../views/recharge-logs.vue");
const DialogFileInput = () => import("../components/dialog-file-input.vue");
const RefundParse = () => import("../views/refund-parse.vue");
const routers = [
    {
        path: 'home/admin/sys/app/cfg', component: CrudRouter
    },
    {
        path: 'home/admin/sys/trace/log', component: CrudRouter,
        meta: {
            listActions: [{
                label: '归档', func() {
                    let self = this;
                    self.$dialog.date('选择归档日期', {}, [{
                        label: '确认', color: 'primary', func(date) {
                            if (!date) { return }
                            self.$axios.get(`/home/admin/sys/trace/log/archive?ts=${date}`).then(r => {
                                if (r.data.status == 'ok') {
                                    self.refresh();
                                    self.$status('归档成功~', 'success');
                                } else {
                                    self.$status(r.data.message || '归档发生错误~', 'error');
                                }
                            })
                        }
                    }]);
                }
            }]
        }
    },
    {
        path: 'home/admin/sys/clazz', component: CrudRouter, meta: {
            selectStyle: 'multi',
            listActions: [{
                label: '归档', confirm: '确认要对选中培训计划归档？', whereSel: true, func() {
                    let self = this, sel = self.selected();
                    if (!sel) {
                        return;
                    }
                    if (self.$store.state.loading.show) {
                        self.$status('请稍后归档～', 'error');
                        return;
                    }
                    self.$loading('正在归档请不要做其它操作～');
                    self.$axios.get(`/home/admin/sys/clazz/archive/${Object.keys(sel).join('_')}/true`).then(() => {
                        self.$loading();
                        self.refresh(true, true);
                        self.$status('归档成功', 'success');
                    });
                }
            }],
            listItemActions: [{
                label: '归档', confirm: '确认要归档吗？', icon: 'archive', func(cfg) {
                    let self = this;
                    if (self.$store.state.loading.show) {
                        self.$status('请稍后归档～', 'error');
                        return;
                    }
                    self.$loading('正在归档请不要做其它操作～');
                    self.$axios.get(`/home/admin/sys/clazz/archive/${cfg.item.id}/true`).then(r => {
                        self.$loading();
                        self.$status(r.data.status == 'ok' ? '归档成功' : (r.data.message || '归档出现错误'), 'success');
                        self.refresh();
                    });
                }
            }, {
                label: '取消归档', confirm: '确认要取消归档吗？', icon: 'cancel', func(cfg) {
                    let self = this;
                    self.$loading('正在取消归档请不要做其它操作～');
                    self.$axios.get(`/home/admin/sys/clazz/archive/${cfg.item.id}/false`).then(r => {
                        self.$loading();
                        self.$status(r.data.status == 'ok' ? '取消归档成功' : (r.data.message || '取消归档出现错误'), 'success');
                        self.refresh();
                    });
                }
            }],
            listItemFilter(i, acts) {
                this.delAction(acts, 'icon', i.archived ? 'archive' : 'cancel');
                return acts;
            }
        }
    },
    {
        path: 'home/admin/sys/acc', component: CrudRouter, meta: {
            listItemActions: [{
                label: '修改密码', icon: 'vpn_key', func(cfg) {
                    let self = this;
                    self.$dialog.crud(`修改密码 - ${cfg.item.name}`, {
                        width: 400,
                        forceEditFormStretch: true,
                        url: '/home/admin/sys/acc', initPanel: 'edit', editable: true, targetId: cfg.item.id, params: { _chgpwd: true },
                        onSaveSuccess() {
                            self.$dialog.close();
                        }
                    });
                }
            }, {
                label: '解除登录锁定', icon: 'lock_open', func(cfg) {
                    let self = this;
                    self.$axios.get(`/home/admin/sys/acc/unlock/${cfg.item.id}`).then(() => {
                        self.refresh();
                    });
                }
            }],
            listItemFilter(i, acts) {
                if (!i.lock) {
                    this.delAction(acts, "icon", "lock_open");
                }
                return acts;
            }
        },
    }, {
        path: 'home/admin/sys/bill', component: CrudRouter, meta: {
            listItemActions: [{
                label: '开具发票', icon: 'done', confirm: '确认发票已开具？', func(cfg) {
                    let self = this;
                    self.$axios.get(`/home/admin/sys/bill/parsed/${cfg.item.id}`).then(() => {
                        self.refresh();
                    });
                }
            }],
            listItemFilter(i, acts) {
                if (i.parsed) {
                    this.delAction(acts, "icon", "done");
                }
                return acts;
            }
        }
    }, {
        path: 'home/admin/sys/stu', component: CrudRouter, meta: {
            desc: '<p class="sys-info">请先搜索需要操作的学员</p>',
            listItemActions: [
                {
                    label: '修改密码', icon: 'vpn_key', func(cfg) {
                        this.$parent.onEdit(cfg.item.id, { _chgpass: true });
                    }
                },
                {
                    label: '照片', icon: 'face', func(cfg) {
                        let self = this, idPhoto = cfg.item.idPhoto.split('/')[0];
                        self.$dialog.img(`初始照片 - ${cfg.item.name}`, {
                            src: `${self.$const.baseUrl}/home/admin/sys/stu/photo/${cfg.item.id}/${idPhoto}`, width: 300
                        }, [{
                            label: '清除', func() {
                                self.$axios.get(`/home/admin/sys/stu/reset/photo/${cfg.item.id}/photo`).then(() => {
                                    self.refresh();
                                    self.$status('清除成功~', 'success');
                                });
                            }
                        }]);
                    }
                }, {
                    label: '身份证正面（国徽）', icon: 'image', func(cfg) {
                        let self = this;
                        self.$dialog.img(`身份证正面（国徽） - ${cfg.item.name}`, {
                            src: `${self.$const.baseUrl}/home/admin/sys/stu/photo_c_f/${cfg.item.id}/${cfg.item.idCardPhotoF}`, width: 500
                        }, [{
                            label: '清除', func() {
                                self.$axios.get(`/home/admin/sys/stu/reset/photo/${cfg.item.id}/photo_c_f`).then(() => {
                                    self.refresh();
                                    self.$status('清除成功~', 'success');
                                });
                            }
                        }]);
                    }
                }, {
                    label: '身份证背面', icon: 'account_box', func(cfg) {
                        let self = this;
                        self.$dialog.img(`身份证背面 - ${cfg.item.name}`, {
                            src: `${self.$const.baseUrl}/home/admin/sys/stu/photo_c_b/${cfg.item.id}/${cfg.item.idCardPhotoB}`, width: 500
                        }, [{
                            label: '清除', func() {
                                self.$axios.get(`/home/admin/sys/stu/reset/photo/${cfg.item.id}/photo_c_b`).then(() => {
                                    self.refresh();
                                    self.$status('清除成功~', 'success');
                                });
                            }
                        }]);
                    }
                },
            ],
            onEditSelect(e) {
                let self = this;
                if (e.field != 'tenantId') { return; }
                self.$dialog.crud('选择租户', { url: '/home/admin/sys/tenant', selectStyle: 'single', createable: false, editable: false }, [{
                    label: '确认', color: 'primary', func(sel) {
                        if (sel) {
                            let keys = Object.keys(sel);
                            if (keys.length > 0) {
                                let o = sel[keys[0]];
                                e.cb(o.name, o.id);
                            }
                        }
                    }
                }]);
            },
            listItemFilter(i, acts) {
                if (!i.idPhoto) {
                    this.delAction(acts, 'icon', 'face');
                }
                if (!i.idCardPhotoF) {
                    this.delAction(acts, 'icon', 'image');
                }
                if (!i.idCardPhotoB) {
                    this.delAction(acts, 'icon', 'account_box');
                }
                return acts;
            }
        }
    },
    {
        path: 'home/admin/sys/refund/log', component: CrudRouter, meta: {
            desc: '<p class="sys-info">下面为已处理的退课/退费记录，可以点击右上角按钮<b>退课/退费处理</b>进行退课退费。</p>',
            createable: false, listActions: [{
                label: '退课/退费处理', func() {
                    this.$router.push('/console/home/admin/sys/refund/log/stu');
                }
            }]
        },
        children: [
            {
                path: 'stu', component: RefundParse, meta: {
                    name: '退课/退费处理'
                }
            }
        ]
    },
    { path: 'home/admin/sys/se/logs', component: StuExceptionLogs },
    {
        path: 'home/admin/sys/tenant', component: CrudRouter, meta: {
            listItemActions: [{
                label: '切换到该企业', icon: 'link', func(cfg) {
                    let self = this;
                    self.$axios.get(`/home/admin/sys/tenant/change/to/${cfg.item.id}`).then(r => {
                        if (r.data && r.data.status == 'ok') {
                            let { tid } = self.$query();
                            window.location = '/s/a/index.html' + (tid ? `?tid=${tid}` : '');
                        } else {
                            self.$status(r.data.message || '切换不成功～', 'error');
                        }
                    });
                }
            },
            {
                label: '账号管理', icon: 'perm_identity', func(cfg) {
                    this.$router.push(`/console/home/admin/sys/tenant/acc/${cfg.item.id}`, `账号管理 - ${cfg.item.name}`);
                }
            }, {
                label: '下级所有账号管理', icon: 'people_outline', func(cfg) {
                    this.$router.push(`/console/home/admin/sys/tenant/allacc/${cfg.item.id}`, `下级所有分配账号管理 - ${cfg.item.name}`);
                }
            }, {
                label: '批量设置权限', icon: 'portrait', func(cfg) {
                    let self = this;
                    self.$dialog.crud(`批量设置权限 - ${cfg.item.name}`, {
                        forceEditFormStretch: true,
                        url: '/home/admin/sys/tenant/acc', initPanel: 'edit', createable: true, params: { _tid: cfg.item.id, _a_role: true }, onSaveSuccess() {
                            self.$dialog.close();
                            self.$status('批量设置成功～', 'success');
                        }
                    });
                }
            }, {
                label: '收费方案管理', icon: 'payment', func(cfg) {
                    this.$router.push(`/console/home/admin/sys/tenant/price/rule/${cfg.item.id}`, `收费方案设置 - ${cfg.item.name}`);
                }
            },
            {
                label: '启用导出试卷', confirm: '确定启用吗？', icon: 'print', func(cfg) {
                    let self = this;
                    self.$axios.get(`/home/admin/sys/tenant/export/paper/${cfg.item.id}/${cfg.item.exportPaper === false ? true : false}`).then((r) => {
                        if (r.data && r.data.status == 'ok') {
                            self.$status('操作成功！', 'success');
                            self.refresh();
                            return;
                        }
                        self.$status(r.data && r.data.message ? r.data.message : '出现错误', "error");
                    });
                }
            }, {
                label: 'API权限设置', icon: 'device_hub', func(cfg) {
                    this.$dialog.crud(`API权限设置 - ${cfg.item.name}`, {
                        url: '/home/admin/sys/tenant/api', params: { _tid: cfg.item.id }
                    });
                }
            }, {
                label: '其它自定义设置', icon: 'more_horiz', func(cfg) {
                    this.$parent.onEdit(cfg.item.id, { _ext: true });
                }
            }, {
                label: '课堂培训课件', icon: 'playlist_play', func(cfg) {
                    this.$router.push(`/console/home/admin/sys/tenant/clzroom/courseware/${cfg.item.id}`, `课堂培训课件设置 - ${cfg.item.name}`);
                }
            }, {
                label: '设置微信模版消息', icon: 'add_alarm', func(cfg) {
                    let self = this
                    self.$dialog.crud('设置微信模版消息模版', {
                        width: 600,
                        url: '/home/admin/sys/alert/wx/msg/tmpl', forceEditFormStretch: true, targetId: '0', params: { _tid: cfg.item.id }, editable: true, initPanel: 'edit', desc: '需设置微信服务号相关信息后才能生效', onSaveSuccess() {
                            self.$dialog.close()
                            self.$status('设置成功～', 'success')
                        }
                    });
                }
            }],
            listItemFilter(i, acts) {
                let isSuper = this.$isSuperman(), isRecharge = isSuper || this.$isInRole('ROLE_RECHARGE');
                if (!isSuper) {
                    if (!this.$isInRole('ROLE_CHG_ORG')) {
                        this.delAction(acts, "icon", "link");
                    }
                    this.delAction(acts, "icon", "print");
                    this.delAction(acts, 'icon', 'add_alarm');
                } else if (i.exportPaper === true) {
                    let act = acts.find(a => a.icon == "print");
                    act.icon = "print_disabled";
                    act.label = "关闭导出试卷";
                    act.confirm = '确定关闭吗？';
                }
                if (!isRecharge || this.$dictVal(i.feeMode) == 1) {
                    this.delAction(acts, "icon", "payment");
                }
                if (!this.$isInRole('ROLE_TENANT_C_ROOM')) {
                    this.delAction(acts, "icon", "playlist_play");
                }
                return acts;
            }
        },
        children: [{
            path: 'price/rule/:_tid', component: CrudRouter, meta: {
                url: '/home/admin/sys/price/rule', name: '收费方案管理'
            }
        }, {
            path: 'acc/:_tid', component: CrudRouter, meta: {
                name: '账号管理',
                url: '/home/admin/sys/tenant/acc', searchable: false,
                listItemActions: [{
                    label: '修改密码', icon: 'vpn_key', func(cfg) {
                        this.$parent.onEdit(cfg.item.id, { _chgpwd: true });
                    }
                }, {
                    label: '以该账号切换到对应企业', icon: 'link', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/sys/tenant/change/to/${self.$route.params._tid}?_aid=${cfg.item.id}`).then(r => {
                            if (r.data && r.data.status == 'ok') {
                                let { tid } = self.$query();
                                window.location = '/s/a/index.html' + (tid ? `?tid=${tid}` : '');
                            } else {
                                self.$status(r.data.message || '切换不成功～', 'error');
                            }
                        });
                    }
                }, {
                    label: '解除登录锁定', icon: 'lock_open', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/sys/tenant/acc/unlock/${cfg.item.id}`).then(() => {
                            self.refresh();
                        });
                    }
                }],
                listItemFilter(i, acts) {
                    if (!i.lock) {
                        this.delAction(acts, "icon", "lock_open");
                    }
                    return acts;
                }
            },
        }, {
            path: 'allacc/:_tid', component: CrudRouter, meta: {
                name: '所有账号管理',
                url: '/home/admin/sys/tenant/acc', searchable: true, createable: false, params: { _all: 'true' },
                listActions: [{
                    label: '导出', func() {
                        let self = this;
                        window.open(`${self.$const.baseUrl}/home/admin/sys/tenant/acc/export.xlsx?_tid=${self.$route.params._tid}&_all=true`);
                    }
                }],
                listItemActions: [{
                    label: '修改密码', icon: 'vpn_key', func(cfg) {
                        this.$parent.onEdit(cfg.item.id, { _chgpwd: true });
                    }
                }, {
                    label: '以该账号切换到对应企业', icon: 'link', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/sys/tenant/change/to/${self.$route.params._tid}?_aid=${cfg.item.id}`).then(r => {
                            if (r.data && r.data.status == 'ok') {
                                let { tid } = self.$query();
                                window.location = '/s/a/index.html' + (tid ? `?tid=${tid}` : '');
                            } else {
                                self.$status(r.data.message || '切换不成功～', 'error');
                            }
                        });
                    }
                }, {
                    label: '解除登录锁定', icon: 'lock_open', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/sys/tenant/acc/unlock/${cfg.item.id}`).then(() => {
                            self.refresh();
                        });
                    }
                }],
                listItemFilter(i, acts) {
                    this.delAction(acts, '__tag', 'edit');
                    if (!i.lock) {
                        this.delAction(acts, "icon", "lock_open");
                    }
                    return acts;
                }
            }
        }, {
            path: 'clzroom/courseware/:_tid', component: CrudRouter, meta: {
                name: '线下培训课件',
                url: '/home/admin/sys/clzroom/courseware',
                editable: false,
                listItemActions: [{
                    label: '预览', icon: 'visibility', func(cfg) {
                        let self = this;
                        self.$dialog.component(cfg.item.name || cfg.item.coursewareName, "courseware-view", {
                            targetId: cfg.item.coursewareId,
                            fullscreen: true
                        });
                    }
                }]
            }
        }]
    }, {
        path: 'home/admin/sys/t_acc', component: CrudRouter, meta: {
            url: '/home/admin/sys/tenant/acc', createable: false, listItemActions: [{
                label: '修改密码', icon: 'vpn_key', func(cfg) {
                    this.$parent.onEdit(cfg.item.id, { _chgpwd: true });
                }
            }],
            listItemFilter(i, acts) {
                this.delAction(acts, '__tag', 'edit');
                return acts;
            }
        }
    },
    {
        path: 'home/admin/sys/price/rule', component: CrudRouter, meta: {
            createable: false,
            listItemActions: [{
                label: '充值管理', icon: 'payment', func(cfg) {
                    this.$router.push(`/console/home/admin/sys/price/rule/recharge/${cfg.item.id}`, `充值管理 - ${cfg.item.tenantName} ${cfg.item.name}`);
                }
            }]
        },
        children: [{
            path: 'recharge/:_rid', component: CrudRouter, meta: {
                url: '/home/admin/sys/recharge',
                name: '充值记录', listItemActions: [{
                    label: '消费课次记录', icon: 'timeline', func(cfg) {
                        this.$dialog.component(`消费课次记录 - ${cfg.item.name}`, RechargeLogs, { _rid: cfg.item.id });
                    }
                }]
            }
        }]
    },
    {
        path: 'home/admin/sys/price/clazz', component: CrudRouter, meta: {
            selectStyle: 'multi',
            editable: false,
            listActions: [{
                label: '审核通过', whereSel: true, func() {
                    let self = this, sel = self.selected();
                    if (!sel) {
                        return;
                    }
                    self.$axios.get(`/home/admin/sys/price/clazz/status/${Object.keys(sel).join('_')}/true`).then(() => {
                        self.refresh(false, true);
                        self.$status('操作完成', 'success');
                    });
                }
            }, {
                label: '审核不通过', whereSel: true, func() {
                    let self = this, sel = self.selected();
                    if (!sel) {
                        return;
                    }
                    self.$axios.get(`/home/admin/sys/price/clazz/status/${Object.keys(sel).join('_')}/false`).then(() => {
                        self.refresh(false, true);
                        self.$status('操作完成', 'success');
                    });
                }
            }],
            listItemActions: [
                {
                    label: '培训方案', icon: 'calendar_today', func(cfg) {
                        this.$dialog.component(`培训方案 - ${cfg.item.name}`, "clazzrule-view", { targetId: this.$dictVal(cfg.item.ruleId), fullscreen: true });
                    }
                },
                {
                    label: '审核通过', confirm: '确认审核通过？', icon: 'done', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/sys/price/clazz/status/${cfg.item.id}/true`).then(() => {
                            self.refresh();
                        });
                    }
                },
                {
                    label: '审核不通过', confirm: '确认审核不通过？', icon: 'clear', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/sys/price/clazz/status/${cfg.item.id}/false`).then(() => {
                            self.refresh();
                        });
                    }
                }
            ]
        }
    },
    {
        path: 'home/admin/sys/domain', component: CrudRouter
    },
    {
        path: 'home/admin/sys/app', component: CrudRouter
    },
    {
        path: 'home/admin/sys/alert/rule', component: CrudRouter
    },
    {
        path: 'home/admin/sys/report/tmpl', component: CrudRouter, meta: {
            url: 'home/admin/sys/report/tmpl/g',
            listActions: [
                {
                    label: '模版编译&PDF转换', func() {
                        let self = this;
                        self.$dialog.component('选择模版', DialogFileInput, { width: 400, formUrl: `${self.$const.baseUrl}/home/admin/sys/report/tmpl/t/compile_to_pdf` });
                    }
                }
            ],
            listItemActions: [{
                label: '模板设置', icon: 'list', func(cfg) {
                    let self = this;
                    self.$router.push(`/console/home/admin/sys/report/tmpl/t/${cfg.item.id}`, `模板设置 - ${cfg.item.name}`);
                }
            }]
        },
        children: [{
            path: 't/:_gid', component: CrudRouter, meta: {
                name: '模板设置',
                url: 'home/admin/sys/report/tmpl/t'
            }
        }]
    }
];

export default {
    routers: routers
}